// tslint:disable-next-line:no-var-requires
const _ = require('lodash');

import { Course } from '@/data/hikari/course';
import { Option } from '@/data/hikari/option';
import { Phone } from '@/data/hikari/phone';
import { Router } from '@/data/hikari/router';
import { StaticIp } from '@/data/hikari/staticIp';

import {
  HikariData,
  LineData,
  BuildingData,
  PhonePlanData,
  PhoneOptionData,
  RouterData,
  PhoneCampaignData,
} from '@/@types/json/hikari';

export class HikariConfig {
  public courses: Course[] = [];
  public phones: Phone[] = [];
  public code: number;
  public router: Router[] = [];
  public staticIps: StaticIp[] = [];
  public phoneCampaigns: PhoneCampaignData[] = [];

  constructor(config: HikariData) {
    this.code = config.code;

    _.each(config.ルータ, (routerData: RouterData, routerKey: string) => {
      this.router.push(new Router(routerKey, routerData.月額特典料金, routerData.月額標準料金))
    });

    _.each(config.回線, (lineData: LineData, lineKey: string) => {
      _.each(
        lineData.建物,
        (buildingData: BuildingData, buildingKey: string) => {
          this.courses.push(new Course(lineData.id, lineKey, buildingData));
        }
      );
    });

    _.each(config.光電話.特典, (phoneCampaignData: PhoneCampaignData, phoneKey: string) => {
      this.phoneCampaigns.push(phoneCampaignData);
    });

    _.each(config.光電話.プラン, (planData: PhonePlanData, planKey: string) => {
      const options: Option[] = [];
      _.each(
        config.光電話.オプション,
        (optionData: PhoneOptionData, optionKey: string) => {
          if (optionData.プラン.some((e: string) => e === planKey)) {
            options.push(new Option(optionData.id, optionKey, optionData));
          }
        }
      );
      this.phones.push(
        new Phone(
          planData.id,
          planKey,
          planData.名前,
          planData.初期費用,
          planData.月額費用,
          options
        )
      );
    });
    this.staticIps = Object.entries(config.光固定IP).reduce(
      (array, [key, value]) => {
        const staticIp = new StaticIp(
          value.名前,
          value.id,
          value.初期費用,
          value.月額費用
        );
        array.push(staticIp);
        return array;
      },
      this.staticIps
    );
  }

  public findPhoneCampaign(name: string): PhoneCampaignData | undefined {
    return this.phoneCampaigns.find(e => e.名前 === name);
  }

  public findCourse(
    entryTypeId: string,
    buildingId: string,
    currentUsageType: string,
    applyTypeId: string
  ): Course | undefined {
    return this.courses.find(
      e => e.entryTypeId === entryTypeId
        && e.buildingId === buildingId
        && e.applyTypeId === applyTypeId
        && e.currentUsageType === currentUsageType
    );
  }

  public findPhone(id: string): Phone | undefined {
    return this.phones.find(e => e.id === id);
  }

  public findStaticIp(id: string): StaticIp | undefined {
    return this.staticIps.find(e => e.id === id);
  }

  public findRouter(id: string): Router | undefined {
    return this.router.find(e => e.routerId === id);
  }
}
